// libraries
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { OnboardingType } from "../onboarding";
// styles
import styles from "../styles.module.scss";

interface Props {
  type: OnboardingType;
}

const Second = ({ type = OnboardingType.LARGE }: Props) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div
        className={classNames(
          styles.image_wrapper,
          type === OnboardingType.SMALL && styles.image_wrapper_smaller
        )}>
        <img src="/assets/images/svg/onboarding-two.svg" />
      </div>
      <div
        className={classNames(
          styles.text_wrapper,
          type === OnboardingType.SMALL && styles.text_wrapper_smaller
        )}>
        {type === OnboardingType.SMALL ? (
          <p className={classNames("subtitle4", "centerAlign")}>
            {t("lbl_item_onboarding_screen_3_title")}
          </p>
        ) : (
          <h2 className={classNames(styles.onboardingText, "g900")}>
            {t("lbl_item_onboarding_screen_3_title")}
          </h2>
        )}

        {type === OnboardingType.LARGE && (
          <p className={classNames(styles.onboardingText, "p1", "g700")}>
            {t("lbl_item_onboarding_screen_3_desc")}
          </p>
        )}
      </div>
    </div>
  );
};

export default Second;
